import DtoReferencial from './DtoReferencial'

export default class DtoAltimetrySystemNature extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
